import type { ValueOf } from 'type-fest';

import type { TaskType } from '../react-query/useGetTasks';
import type { TProcedure } from '../react-query/useVisitSummaries';

export type PatientListModes = 'DAILY_HUDDLE' | 'RECENT_VISITS';

export const PatientListModesMap = {
  DailyHuddle: 'DAILY_HUDDLE',
  RecentVisits: 'RECENT_VISITS',
};

export const SelectedUserExperience = {
  Default: 'Default',
  Limited: 'Limited',
} as const;
export type SelectedUserExperienceType = keyof typeof SelectedUserExperience;

export const RecentVisitsSortFilter = {
  APPOINTMENT_TIME_LATEST: 'Appt. Time (latest)',
  TREATMENT_PRESENCE_RESTO: 'Resto Findings',
  TREATMENT_PRESENCE_PERIO: 'Perio Findings',
  TREATMENT_PRESENCE_ENDO: 'Endo Findings',
  TODAYS_RADIOGRAPHS: "Today's Radiographs",
} as const;

export type TRecentVisitsSortFilter = ValueOf<typeof RecentVisitsSortFilter>;

export enum SortFilterEnum {
  APPOINTMENT_TIME_EARLIEST = 'Appt. Time (earliest)',
  APPOINTMENT_TIME_LATEST = 'Appt. Time (latest)',
  RADIOGRAPH_PRESENCE = 'Radiographs available',
  TREATMENT_PRESENCE_RESTO = 'Resto Findings',
  TREATMENT_PRESENCE_PERIO = 'Perio Findings',
  TREATMENT_PRESENCE_ENDO = 'Endo Findings',
}

export enum SortFilterEnumV2 {
  APPOINTMENT_TIME_EARLIEST = 'Appt. Time (earliest)',
  RADIOGRAPH_PRESENCE = 'Radiographs available',
  TREATMENT_PRESENCE_RESTO = 'Resto Findings',
  TREATMENT_PRESENCE_PERIO = 'Perio Findings',
  TREATMENT_PRESENCE_ENDO = 'Endo Findings',
}

export type PatientListSortFilterEnum =
  | SortFilterEnum
  | SortFilterEnumV2
  | TRecentVisitsSortFilter;

export type RecommendationFilter = TProcedure['name'] | 'ALL_OPPORTUNITIES';
export type SelectedCountsFilter = TaskType | RecommendationFilter;

export type CountOfRblLinesBySeverity = {
  severe: number;
  moderate: number;
  mild: number;
  normal: number;
};

export enum FindingType {
  resto = 'Resto',
  perio = 'Perio',
  endo = 'Endo',
}

export interface Provider {
  firstName: string;
  lastName: string;
  displayName: string;
}

export enum SortParam {
  ascending = 'ASC',
  descending = 'DESC',
}

export interface FindingCount {
  pathologyCount: number;
  hasUnknown: boolean;
  toothNumbers: string[] | null;
  analysesIds?: string[];
}
export interface FindingCounts {
  allRestoFindingCounts: FindingCount;
  perioAllQuadrants: string[] | null;
}

export const SelectJumpToCurrentAppt = {
  Default: 'false',
  True: 'true',
} as const;
export type SelectJumpToCurrentApptType = keyof typeof SelectJumpToCurrentAppt;
